import React, {useEffect, useState} from 'react';
import './LoadingScreen.css';
import QuoteRotator from "../QuoteRotator/QuoteRotator";
import {LoadedImage} from "../EmblaCarousel/FactionsCarousel";

const FAKE_PROGRESS_TARGET = 17;
const FAKE_PROGRESS_DURATION_MS = 6000;
const FAKE_PROGRESS_INTERVAL_MS = 50;

function LoadingScreen({progress}) {
  const [fakeProgress, setFakeProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const nextFake = Math.min(
        FAKE_PROGRESS_TARGET,
        (elapsed / FAKE_PROGRESS_DURATION_MS) * FAKE_PROGRESS_TARGET
      );
      setFakeProgress(nextFake);

      if (nextFake >= FAKE_PROGRESS_TARGET) {
        clearInterval(interval);
      }
    }, FAKE_PROGRESS_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  const displayedProgress = Math.min(
    100,
    Math.max(0, Math.round(Math.max(fakeProgress, progress)))
  );

  return (
    <>
      <LoadedImage
        className={'loading-screen-bust'}
        src={'/img/other/strategikon_bust.png'}
      />
      <div className="loading-screen-panel">
        <h1 className="loading-screen-title">Загрузка</h1>
        <div className="loading-screen-bar-container">
          <div
            className="loading-screen-bar-fill"
            style={{width: `${displayedProgress}%`}}
          />
        </div>
        <div className="loading-screen-percent">{displayedProgress}%</div>
      </div>

      <QuoteRotator/>
    </>
  );
}

export default LoadingScreen;
